const formatValue = (value: number, currencyCode: string): string =>
  Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
  })
    .format(value)
    .replace(/^(\D+)/, '$1 ');

export default formatValue;
